import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Shoot.css";
import AOS from "aos";
import "aos/dist/aos.css";
import shootCover1 from "../assets/shootCover1.jpg";
import shootCover2 from "../assets/shootCover2.jpg";
import shootCover3 from "../assets/shootCover3.jpg";
import shootCover4 from "../assets/shootCover4.jpg";
import shootCover5 from "../assets/shootCover5.jpg";
import shootCover6 from "../assets/shootCover6.jpg";
import shootWeddingBanner from "../assets/shoot-wedding-banner.jpg";

const shoots = [
  {
    id: 1,
    title: "Sushmita & Vamsi",
    location: "Hyderabad",
    description:
      "Modern love captured amidst city lights — a cinematic wedding story.",
    cover: shootCover6,
  },
  {
    id: 2,
     title: "Spandana & Nithin",
    location: "Jaipur Fort",
    description:
      "Soft golden hues of dusk lighting up timeless love and togetherness.",
    cover: shootCover5,
  },
  {
    id: 3,
    title: "Supriya & Sai",
    location: "Tirupati Temple",
    description:
      "A traditional ceremony where devotion meets emotion in every frame.",
    cover: shootCover4,
  },
  {
    id: 4,
    title: "Susmitha & Srujan",
    location: "Udaipur, Rajasthan",
    description:
      "A royal wedding captured amidst lakes and palaces — pure elegance and tradition.",
    cover: shootCover1,
  },
  {
    id: 5,
     title: "Raagha & Prem",
    location: "Goa Beach Wedding",
    description:
      "Love and laughter captured against the sunset glow — candid moments of pure joy.",
    cover: shootCover2,
  },
  {
    id: 6,
    title: "Ashwini & Manjunath",
    location: "Coorg, Karnataka",
    description:
      "A nature-inspired pre-wedding shoot that blends serenity, love, and forest vibes.",
    cover: shootCover3,
  }
];

const Shoot = () => {

    useEffect(() => {
      AOS.init({
        duration: 1000, // animation duration
        once: true,     // animate only once
        disable: 'mobile' // disable on mobile devices
      });
    }, []);

  const navigate = useNavigate();

  return (
    <div className="shoot-page bg-black text-light">
      {/* ===== Intro Section ===== */}
      <section
        className="shoot-intro position-relative text-center text-light"
        style={{
          backgroundImage: `url(${shootWeddingBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
        }}
        data-aos="zoom-out">
        <div className="intro-overlay" ></div>
        <div className="intro-content container text-center text-shadow">
  <h2 className="fw-bold mb-3 glowing-text">
    Where Love Meets the Lens 💞
  </h2>
  <p className="lead fs-5">
    Every wedding is a story waiting to be told of stolen glances,
    heartfelt laughter, and promises made beneath the stars. Through
    every frame, we celebrate the magic of love, the bond of
    togetherness, and the artistry that transforms fleeting moments
    into timeless memories.
    <br /> <br />
    Step into our world of beautiful wedding stories crafted with
    emotion, passion, and light.
  </p>
  <p className="lead fs-5 mt-3">
    From timeless ceremonies to candid laughter, each celebration we
    captured reflects love, emotions, and unforgettable moments
    step into these memories crafted through our lens.
  </p>
  <strong className="fs-5 glowing-text">
    ✨ Let’s Explore Some of Our Most Cherished Wedding Stories 💍
  </strong>
</div>

      </section>



      {/* ===== Wedding Stories Grid ===== */}
      <section className="container py-5">
        <div className="row g-4">
          {shoots.map((shoot) => (
            <div key={shoot.id} className="col-md-6" data-aos="zoom-out">
              <div className="shoot-card position-relative overflow-hidden rounded-4 shadow-lg">
                <img
                  src={shoot.cover}
                  alt={shoot.title}
                  className="w-100 shoot-img"
                />
                <div className="shoot-overlay d-flex flex-column justify-content-center align-items-center">
                  <button
                    className="btn btn-danger fw-bold px-4 py-2"
                    onClick={() => navigate(`/shoot/${shoot.id}`)}>
                    ✨ View Story
                  </button>
                </div>
                <div className="shoot-info p-3">
                  <h5 className="fw-bold text-danger">{shoot.title}</h5>
                  {/* <small className="text-white-50">{shoot.location}</small> */}
                  <p className="mt-2">{shoot.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Shoot;
